import React from "react";

import style from './style.module.css';

const Spacer = ({ size = 30 }) => {
    return (
        <div className={style[`Spacer${size}`] || style.Spacer16}></div>
    );
}

export default Spacer;